import { render } from "./IncomeStatementSettings.vue?vue&type=template&id=2b561b66&scoped=true"
import script from "./IncomeStatementSettings.vue?vue&type=script&lang=js"
export * from "./IncomeStatementSettings.vue?vue&type=script&lang=js"

import "./IncomeStatementSettings.vue?vue&type=style&index=0&id=2b561b66&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b561b66"]])

export default __exports__